import React, { useEffect, useState } from 'react';
import { Upload } from 'lucide-react';

const DEFAULT_HERO_IMAGE = 'https://images.unsplash.com/photo-1577495508048-b635879837f1?auto=format&fit=crop&w=1600&q=80';

export default function HomepageEditor({ imageUrl = '', onSave }) {
  const [savedImageUrl, setSavedImageUrl] = useState(imageUrl);
  const [pendingImageUrl, setPendingImageUrl] = useState(imageUrl);
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');

  useEffect(() => {
    setSavedImageUrl(imageUrl);
    setPendingImageUrl(imageUrl);
  }, [imageUrl]);

  const handleUpload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;

    setUploading(true);
    setError('');
    setNotice('');
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch('/api/uploads', {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Falha ao enviar a imagem.');
      setPendingImageUrl(data.url);
    } catch (uploadError) {
      setError(uploadError.message || 'Não foi possível enviar a imagem.');
    } finally {
      setUploading(false);
    }
  };

  const handleSave = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');
    setNotice('');
    try {
      await onSave(pendingImageUrl);
      setSavedImageUrl(pendingImageUrl);
      setNotice('Imagem da página inicial atualizada.');
    } catch (saveError) {
      setError(saveError.message || 'Não foi possível salvar a imagem.');
    } finally {
      setSaving(false);
    }
  };

  const previewImage = pendingImageUrl || DEFAULT_HERO_IMAGE;

  return (
    <form className="admin-homepage-editor" onSubmit={handleSave}>
      <div className="admin-homepage-editor__intro">
        <h2 className="font-display">Imagem de abertura</h2>
        <p>Esta é a primeira imagem exibida no site. Envie uma foto horizontal para o melhor resultado. Arquivos JPEG, PNG ou WebP de até 5 MB.</p>
      </div>

      <div className="admin-homepage-editor__preview">
        <img src={previewImage} alt="Prévia da imagem de abertura da página inicial" />
      </div>

      <div className="admin-homepage-editor__actions">
        <label className="btn btn--outline admin-homepage-editor__upload">
          <Upload size={15} /> {uploading ? 'Enviando...' : pendingImageUrl ? 'Trocar imagem' : 'Enviar imagem'}
          <input type="file" accept="image/jpeg,image/png,image/webp" onChange={handleUpload} disabled={uploading || saving} />
        </label>
        <button type="submit" className="btn btn--solid" disabled={saving || uploading || pendingImageUrl === savedImageUrl}>
          {saving ? 'Salvando...' : 'Salvar imagem'}
        </button>
      </div>

      {error && <p className="admin-homepage-editor__message is-error" role="alert">{error}</p>}
      {notice && <p className="admin-homepage-editor__message" role="status">{notice}</p>}
    </form>
  );
}
